import { OctopusPurpleLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  avatar: string | null
}

export const ProjectAvatar: React.FC<Props> = ({ avatar }) => (
  <div className={css.project_dropdown_avatar}>
    {avatar && (
      <img
        className={css.avatar_logo}
        src={avatar}
        alt="project-avatar"
        id="project-avatar"
      />
    )}

    {!avatar && <OctopusPurpleLogo className={css.avatar_icon} />}
  </div>
)
